import { render, staticRenderFns } from "./OrderMainStatus.vue?vue&type=template&id=6c57b5f6&scoped=true"
import script from "./OrderMainStatus.vue?vue&type=script&lang=js"
export * from "./OrderMainStatus.vue?vue&type=script&lang=js"
import style0 from "./OrderMainStatus.vue?vue&type=style&index=0&id=6c57b5f6&prod&lang=scss&scoped=true"
import style1 from "./OrderMainStatus.vue?vue&type=style&index=1&id=6c57b5f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c57b5f6",
  null
  
)

export default component.exports